import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatTime',
    standalone: false
})
export class FormatTimePipe implements PipeTransform {
  transform(time: string): string {
    const [hours, minutes] = time.split(':');
    return `${hours}:${minutes}`;
  }
}

@Pipe({
    name: 'formatTimePeriod',
    standalone: false
})
export class FormatTimePeriodPipe implements PipeTransform {
  transform(time: string): string {
    const hours = parseInt(time.split(':')[0]);
    return hours >= 12 ? 'PM' : 'AM';
  }
} 